import React from 'react';
export function StoryTestimonials() {
  const testimonials = [{
    quote: 'Michael is a great boss, listener and friend. He had a way of getting through all the extraneous noise that surrounds a project so you could focus on what really mattered in getting the product complete and shipped.',
    author: 'Steve Clegg',
    role: 'Director of Engineering (reported to Michael)',
    image: 'https://cdn.magicpatterns.com/uploads/nugkQPGg9KanWBu1hzjJFy/image.jpg'
  }, {
    quote: "He made significant improvements to the Product Management org and really helped me become a more effective manager. He is one of the few managers I've had in my career, who is able to easily connect personally, as well as professionally.",
    author: 'Steve Guttman',
    role: 'Product Management and Strategy (reported to Michael)',
    image: 'https://cdn.magicpatterns.com/uploads/aKNAZCTwfcyT4Qvz47WaYY/image.jpg'
  }];
  return <section className="w-full bg-white py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-421" data-mp="18t2ujcyq5qpz">
      <div className="max-w-4xl mx-auto" data-id="element-422" data-mp="18qzue03uyh7j">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-10 text-center" data-id="element-423" data-mp="13t82v774kx3v">
          What people say about working with me
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-424" data-mp="1ikyqoih936rk">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-10 rounded-lg shadow-sm border-l-4 border-brand-orange flex flex-col h-full" data-id="element-425" data-mp="pu8bvsw5464j" data-mpi={index}>
              <blockquote className="text-brand-navy text-lg leading-relaxed mb-10 flex-grow italic" data-id="element-426" data-mp="kxhw76o8zcjn">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex items-center gap-3 mt-auto" data-id="element-427" data-mp="uss3a8ti6a4a">
                <img src={testimonial.image} alt={testimonial.author} className="w-10 h-10 rounded-full object-cover flex-shrink-0" data-id="element-428" data-mp="2a9sgn7xgfyec" />
                <div data-id="element-429" data-mp="12ycdjepr0qge">
                  <div className="font-bold text-brand-navy" data-id="element-430" data-mp="12x1694x3h0kj">
                    {testimonial.author}
                  </div>
                  <div className="text-brand-gray-light text-sm" data-id="element-431" data-mp="17z0bylgb49kn">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}